import { useEffect, useRef } from 'react';

const DEFAULT_OPTIONS: IntersectionObserverInit = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5,
};

export const useOnViewportEnter = <T extends Element>(
  callback: () => void,
  options: IntersectionObserverInit = DEFAULT_OPTIONS,
) => {
  const ref = useRef<T>(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          observer.disconnect();
        }
      });
    }, options);

    const htmlDivElement = ref.current;
    if (htmlDivElement) {
      observer.observe(htmlDivElement);
    }

    return () => {
      if (htmlDivElement) {
        observer.unobserve(htmlDivElement);
      }
    };
  }, []);

  return ref;
};
